import type { TreatmentData } from '@common/validation/customControls/osas/osasAllTreatmentsSchemas/types';
import { initialTreatmentChoiceData } from '../osasEvaluationData';

export function calculateTreatmentChoice(
    inProgressTreatments?: TreatmentData,
    treatmentChoiceData = initialTreatmentChoiceData
) {
    if (!inProgressTreatments) {
        return treatmentChoiceData;
    }

    return {
        MRA: Boolean(treatmentChoiceData.MRA || inProgressTreatments.MRA),
        PAP: Boolean(treatmentChoiceData.PAP || inProgressTreatments.CPAP),
        SPT: Boolean(treatmentChoiceData.SPT || inProgressTreatments.SPT),
        lifestyle: Boolean(treatmentChoiceData.lifestyle || inProgressTreatments.lifestyle),
    };
}
